import * as t from 'io-ts';

export const SharingDataDynamicType = t.interface({
    email: t.string,
    types:  t.array(t.string)
});

export type SharingData = t.TypeOf<typeof SharingDataDynamicType>;
